// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import "../stylesheets/application.tailwind.css"


document.addEventListener("turbo:submit-start", (event) => {
  const spinner = document.getElementById("spinner")
  if (spinner) spinner.classList.remove("hidden")
})

document.addEventListener("turbo:submit-end", (event) => {
  const spinner = document.getElementById("spinner")
  if (spinner) spinner.classList.add("hidden")
})

document.addEventListener("turbo:submit-end", (event) => {
  if (event.detail.success) {
    const form = event.target
    form.reset()
  }
})

function closeFlash(el) {
  const box = el || document.getElementById("flash-message")
  if (!box) return
  box.classList.add("opacity-0")
  setTimeout(() => box.remove(), 300)
}

// Auto-close every time Turbo renders new content (including stream updates)
document.addEventListener("turbo:render", () => {
  const box = document.getElementById("flash-message")
  if (box) setTimeout(() => closeFlash(box), 3000)
})

// Delegate clicks so new buttons also work
document.addEventListener("click", (e) => {
  const btn = e.target.closest("#flash-close")
  if (!btn) return
  const box = btn.closest("#flash-message") || document.getElementById("flash-message")
  closeFlash(box)
})